import { FC } from 'react';
import { Field, Image, ImageField } from '@sitecore-jss/sitecore-jss-nextjs';
import classNames from 'classnames';
import { sanitize } from 'isomorphic-dompurify';

import { JabraFocusItem } from '@gn-audio/jss-components';
import { Group } from '@gn-audio/jss-core';

export type ServiceCardType = {
  id: string;
  serviceName: Field<string>;
  serviceDescription: Field<string>;
  serviceImage: ImageField;
};

type ServiceCardProps = {
  serviceCard: ServiceCardType;
  relatedService: Group | undefined;
};

export const ServiceCard: FC<ServiceCardProps> = ({ serviceCard, relatedService }) => {
  return (
    <>
      {relatedService && Object.keys(relatedService).length > 0 && (
        <JabraFocusItem asChild>
          <a
            href={relatedService.pageUrl}
            className={classNames(
              'group relative mx-4 min-h-[460px] flex-1 rounded-3xl hover:no-underline'
            )}
          >
            <div className="absolute inset-0 z-10 rounded-3xl bg-gradient-to-t from-[rgba(0,0,0,0.5)] via-[rgba(0,0,0,0.5)] to-60%" />
            {!!serviceCard.serviceImage?.value && (
              <Image
                field={serviceCard.serviceImage}
                className="absolute h-full w-full rounded-3xl object-cover"
                alt={serviceCard.serviceName?.value}
              />
            )}
            <div className="absolute bottom-0 z-20 w-full px-12 pb-12 text-center text-white">
              <div className="flex flex-col">
                <p className="text-3xl font-bold">{serviceCard.serviceName?.value}</p>
                <p
                  className="text-2xl"
                  dangerouslySetInnerHTML={{
                    __html: sanitize(serviceCard.serviceDescription?.value as string),
                  }}
                />
              </div>
            </div>
          </a>
        </JabraFocusItem>
      )}
    </>
  );
};
